"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_query_1 = require("@tanstack/react-query");
const ui_1 = require("@phishtool/ui");
const _service_1 = require("~service");
const theme_1 = __importDefault(require("~styles/theme"));
const modal_1 = require("@phishtool/modal");
const Providers = ({ children, staticData, query }) => {
    const queryClientToUse = ui_1.isServer ? new react_query_1.QueryClient() : _service_1.queryClient;
    return ((0, jsx_runtime_1.jsx)(react_query_1.QueryClientProvider, { client: queryClientToUse, children: (0, jsx_runtime_1.jsx)(react_query_1.Hydrate, { state: query, children: (0, jsx_runtime_1.jsx)(ui_1.NotificationProvider, { value: staticData.notification || null, children: (0, jsx_runtime_1.jsx)(ui_1.CurrencyProvider, { children: (0, jsx_runtime_1.jsx)(ui_1.DefaultProviders, { theme: theme_1.default, staticData: staticData, children: (0, jsx_runtime_1.jsx)(modal_1.ModalProvider, { blurBackground: true, listenToFragment: true, children: children }) }) }) }) }) }));
};
exports.default = Providers;
